import { useEffect } from "react";
import SectionTitle from "./SectionTitle";
import "../styles/GoogleReviews.css";

// 👇 Your Elfsight widget ID (from your embed code)
const WIDGET_ID = "elfsight-app-f8babb36-d05c-46d9-99df-ac22dd05d40a";

const ELFSIGHT_SCRIPT_ID = "elfsight-platform";
const ELFSIGHT_SRC = "https://elfsightcdn.com/platform.js";

const GoogleReviews = () => {
  useEffect(() => {
    // 👇 Load the Elfsight platform script ONCE
    // (the id-check guard prevents double-loading in React StrictMode)
    if (!document.getElementById(ELFSIGHT_SCRIPT_ID)) {
      const script = document.createElement("script");
      script.id = ELFSIGHT_SCRIPT_ID;
      script.src = ELFSIGHT_SRC;
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <section className="google-reviews">
      <div className="container">
        <SectionTitle
          tag="Testimonials"
          title="What Our Guests Say"
          subtitle="Real reviews from real guests — straight from our Google Business profile."
        />

        {/* 👇 Elfsight widget — reviews are managed from your Elfsight dashboard */}
        <div className="gr-widget-wrap">
          <div className={WIDGET_ID} data-elfsight-app-lazy />
        </div>
      </div>
    </section>
  );
};

export default GoogleReviews;